<template>
    <Modal v-if="show" @close="closeModal">
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <div>
          I understand that I have a time limit of 30 days to fill my barrel, and that after that time,
          my barrel will be sealed and prepared for shipping
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-primary" @click="closeModal">Close</button>
      </template>
    </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
    components: {
        Modal,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        closeModal() {
            this.$emit("close");
        }
    },
}
</script>

<style lang="scss" scoped>

</style>